import { inject, Injectable } from "@angular/core";
import { MCAuthoritiesEventsGeneric, MCAuthoritiesEventsResponseReadiness, MCCustomFunctionsParams } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsResponseReadiness extends MCAuthoritiesEventsResponseReadiness {

    private authoritiesEventsGeneric = inject(MCAuthoritiesEventsGeneric);


    override isRequestResponseReadyChecked(customFunctionsParams: MCCustomFunctionsParams): void {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsParams, 'isRequestResponseReadyChecked');
    }
    override isResponseReadyChecked(customFunctionsParams: MCCustomFunctionsParams): void {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsParams, 'isResponseReadyChecked');
    }
}
